import type {DataObject, TypedImageData} from "@cm/utils"
import {z} from "zod/v4-mini"

export const textureResolution = z.enum(["500px", "1000px", "2000px", "original"])
export type TextureResolution = z.infer<typeof textureResolution>

export type LoadTextureDescriptor = {
    lowRes?: DataObject | TypedImageData
    primary: DataObject | TypedImageData
}

export const imageTextureExtensionSchema = z.enum(["REPEAT", "EXTEND", "CLIP", "MIRROR"])
export type ImageTextureExtension = z.infer<typeof imageTextureExtensionSchema>

export const imageTextureImageColorspaceSettingsNameSchema = z.enum(["Linear", "Non-Color", "sRGB"])
export type ImageTextureImageColorspaceSettingsName = z.infer<typeof imageTextureImageColorspaceSettingsNameSchema>

export const imageTextureInterpolation = z.enum(["Linear", "Cubic", "Closest", "Smart"])
export type ImageTextureInterpolation = z.infer<typeof imageTextureInterpolation>

export const imageTextureProjection = z.enum(["FLAT", "BOX", "SPHERE", "TUBE"])
export type ImageTextureProjection = z.infer<typeof imageTextureProjection>
